import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { tldPromotionsApiClient } from '../Components/TldPromotionsWithPrice/TldPromotionsWithPrice.apiClient';
import { CACHE_FOREVER } from './priceQueries.utils';
import { useIsTldPriceCacheEnabled } from './useIsTldPriceCacheEnabled';
import { useTldPrices } from './useTldPrices';
export const useTldPromotionsWithPrice = (limit, productType) => {
  var _promotions$data;
  const isTldPriceCacheOn = useIsTldPriceCacheEnabled();
  const batchPricedPromotions = tldPromotionsApiClient.hooks.useTldPromotionsWithPrice({
    limit
  }, !isTldPriceCacheOn, {
    useErrorBoundary: false
  });
  const promotions = DomainsApiClient.hooks.useListTldPromotions({
    limit
  }, isTldPriceCacheOn, {
    ...CACHE_FOREVER,
    useErrorBoundary: false
  });
  const tldPromotions = ((_promotions$data = promotions.data) == null ? void 0 : _promotions$data.tldPromotions) ?? [];
  const _useTldPrices = useTldPrices(tldPromotions.flatMap(_ref => {
      let tld = _ref.tld;
      return tld ? [tld] : [];
    }), productType),
    pricesByTld = _useTldPrices.pricesByTld,
    isPricingLoading = _useTldPrices.isLoading;
  if (!isTldPriceCacheOn) {
    return batchPricedPromotions;
  }
  return {
    data: promotions.data && {
      tldPromotionsWithPrice: tldPromotions.map(promotion => ({
        ...promotion,
        pricing: pricesByTld.get(promotion.tld ?? '') ?? {}
      }))
    },
    isLoading: promotions.isLoading || isPricingLoading,
    error: promotions.error
  };
};
//# sourceMappingURL=useTldPromotionsWithPrice.js.map